$(document).ready(function() {
  setTimeout(() => {
    $('.flickity-page-dots').attr('aria-hidden','true');
  }, 1000);
  setTimeout(() => {
    $('.is-selected').removeAttr('aria-hidden','true');
$('.product-index').removeAttr('role','option');
  }, 1000);

  $('.theme-features__image-flip--enabled .reveal .hidden').attr('aria-hidden','true');
    


  setTimeout(() => { 
    $('.slideshow').removeAttr('tabindex','0');
    $('.shogun-accordion-title').attr('role','button');
    $('.shogun-icon-plus').attr('aria-hidden','true');
  $('.featured__collection-carousel.flickity__section').removeAttr('tabindex','0');
  }, 1000);
  $('br').attr('aria-hidden', 'true');
  $('hr').attr('aria-hidden', 'true');
  $('#search-drawer').removeAttr('aria-expanded','true');
  $('.slideout--active').removeAttr('aria-expanded','true');
  $('#slideout-search-sidebar').removeAttr('aria-expanded','true');
  setTimeout(() => {
    $('#slideout-search-sidebar').attr({
      'aria-modal': 'true',
      'role': 'dialog'
    });
  $('#slideout-search-sidebar').attr('aria-hidden', 'true');
  $('.mobile-menu').attr('aria-hidden', 'true');
    
  }, 1000);
  $('.js-quickview-trigger .icon--icon-theme-search.vib-center').attr('aria-label','Quick View');


  let lastTriggeredButton;
  
  // Track the last clicked button
  $(document).on('click', '.js-modal-open.js-quickview-trigger', function () {
    lastTriggeredButton = $(this); // Store the last clicked button
  });

  // Handle close button click
  $(document).on('click', '.js-modal-close', function () {
    if (lastTriggeredButton) {
      lastTriggeredButton.focus(); // Redirect focus back
    }
  });

  let lastClickedButton;

  // Track button click
  jQuery(document).on('click', '.product-listing__quickview-trigger', function() {
      lastClickedButton = jQuery(this);
  });
  
  // Close Function
  function close(openerEl) {
      const activeOpenModals = document.querySelectorAll('.modal--active');
      const openers = document.querySelectorAll(".js-modal-open");
      const closers = document.querySelectorAll(".js-modal-close");
  
      // Remove content if quickview
      if (openerEl && openerEl.getAttribute("aria-controls") === 'modal-quickview') {
          document.querySelector('.js-quickview-content').innerHTML = '';
      }
  
      // Close the Modal
      const wrapper = document.querySelector(".js-modal-toggle-wrapper");
      wrapper.classList.remove("modal--open");
      wrapper.classList.add("modal--closed");
  
      // Close all active modals
      activeOpenModals.forEach(function(activeModalDrawer) {
          if (activeModalDrawer.getAttribute("data-wau-modal")) {
              let elClass = activeModalDrawer.getAttribute("data-wau-modal");
              elClass = "modal-" + elClass + "--open";
              wrapper.classList.remove(elClass);
          }
          activeModalDrawer.classList.remove('modal--active');
      });
  
      // Reset aria-expanded
      openers.forEach(function(opener) {
          opener.setAttribute('aria-expanded', 'false');
      });
  
      // Reset inline styles and body scroll lock
      ['overflow', 'position', 'padding-right', 'top', 'width'].forEach(style => {
          wrapper.style.removeProperty(style);
      });
      document.body.classList.remove('overflow-hidden');
  }
  
  // Handle Escape key press
  jQuery(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
          const activeModalOpener = document.querySelector('.js-modal-open[aria-expanded="true"]');
          if (activeModalOpener) {
              close(activeModalOpener);
  
              // Return focus to the last clicked button
              if (lastClickedButton) {
                  setTimeout(() => lastClickedButton.focus(), 500);
              }
          }
      }
  });
});

//external warnings
$(document).ready(function() {
    $('a[href="https://us.fsc.org/en-us/%20certification)"],a[href="https://carolinak.loopreturns.com/#/"],a[href="https://www.google.com/maps/dir/25.8394142,-80.1986642/Carolina+K+Flagship+Design+District,+Northeast+2nd+Avenue,+Miami,+FL/@25.8278314,-80.2053722,15z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x88d9b1de0f9b438b:0xde3b830c17167894!2m2!1d-80.1916023!2d25.8157537?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D"],a[href="https://www.google.com/maps/place/Carolina+K/@25.8157537,-80.26782,13z/data=!4m10!1m2!2m1!1scarolina+k+store!3m6!1s0x88d9b1de0f9b438b:0xde3b830c17167894!8m2!3d25.8157537!4d-80.1916023!15sChBjYXJvbGluYSBrIHN0b3JlkgEOY2xvdGhpbmdfc3RvcmXgAQA!16s%2Fg%2F11y352crrt?entry=ttu"],a[href="https://www.googhttps://www.google.com/maps/place/7924+NE+2nd+Ave,+Miami,+FL+33138/@25.8484022,-80.1957976,17z/data=!3m1!4b1!4m5!3m4!1s0x88d9b178d16543cb:0xebddde8945437b92!8m2!3d25.8484022!4d-80.1936089"],a[href="https://www.google.com/maps?daddr=33140+COLLINS+AVENUE+MIAMI+FL+33140"]').each(function() {
        var originalTitle = $(this).text();
  var trimmedTitle = originalTitle.length > 20 ? originalTitle.substring(0, 100) + '' : originalTitle;
      $(this).attr('aria-label', trimmedTitle + ' (open in a new window)');
      $(this).attr('target', '_blank');
      $(this).removeAttr('title');});
  });

  

  //phone number warnings
  $(document).ready(function() {
    $('a[href="tel:+13475251809"],a[href="tel:+13475251809"]').each(function() {
        var originalTitle = $(this).text();
        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
        $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');
        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });
  $(document).ready(function() {
    $('a[href="mailto:websales@carolinak.com"],a[href="mailto:websales@carolinak.com"],a[href="mailto:info@carolinak.com"]').each(function() {
        var originalTitle = $(this).text();
        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
        $(this).attr('aria-label', 'Email Address: ' + trimmedTitle + ' (open in a new window)');
        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });
  $(document).ready(function() {
    $('a[href="https://www.thezoereport.com/wellness/how-to-prioritize-mental-wellness-female-founders-meditation-yoga-walking"],a[href="https://fashionweekdaily.com/ethical-designer-carolina-k-on-slow-fashion-famous-fans-and-15-years-in-business/"],a[href="https://www.vogue.mx/moda/articulo/carolina-k-marca-latinoamericana-con-disenos-artesanales-y-latinoamericanos"],a[href="https://wp.wearedore.com/style/the-dresses-of-carolina-k/"],a[]').each(function() {
        var originalTitle = $(this).text();
        var trimmedTitle = originalTitle.length > 20 ? originalTitle.substring(0, 100) + '' : originalTitle;
        $(this).attr('aria-label', trimmedTitle + ' (open in a new window)');
        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });

$(document).on('keydown', '.megamenu.nestedmm', function (event) {
  if (event.key === 'Escape') {
      const $dropdown = $(this); // The dropdown element
      const $button = $dropdown.siblings('.js-menu-link'); // The associated button (sibling)

      // Remove 'menu-item' class
      $dropdown.removeClass('menu-item');

      // Update aria-expanded to false
      $button.attr('aria-expanded', 'false');
  }
});

$(document).on('keydown', '.dropdown.js-dropdown', function (event) {
  if (event.key === 'Escape') {
      const $dropdown = $(this); // The dropdown element
      const $button = $dropdown.siblings('.js-menu-link'); // The associated button (sibling)

      // Remove 'menu-item' class
      $dropdown.removeClass('menu-item');

      // Update aria-expanded to false
      $button.attr('aria-expanded', 'false');

  }
});

$(document).on('click', '.product-listing__quickview-trigger', function () {
  lastFocusedElement = $(this); // Store clicked button
  const checkModal = setInterval(function () {
    const $modal = $('.modal__container.modal--active');
    if ($modal.length) {
      $modal.attr('tabindex', '-1').focus(); // Focus modal
      clearInterval(checkModal); // Stop checking
    }
  }, 100);  
});

$(document).on('click', '.button-as-link.slideout__trigger-search.js-slideout-open', function () {
  // Wait for the drawer to become active, then focus on it
  setTimeout(function () {
    const $drawer = $('#slideout-search-sidebar');
    if ($drawer.length) {
      $drawer.attr('tabindex', '-1').focus();  // Ensure the drawer is focusable and set focus
    }
  }, 100);  // Delay to ensure drawer is fully opened
});

$(document).on('click', function(e) {
  // Check if click happened outside the megamenu or menu link
  if (!$(e.target).closest('.megamenu.nestedmm.menu-item, .js-menu-link').length) {
    // Remove 'menu-item' class
    $('.megamenu.nestedmm').removeClass('menu-item');

    // Set aria-expanded to false
    $('.js-menu-link').attr('aria-expanded', 'false');
  }
});

$(document).on('click', function(e) {
  // Check if click happened outside the megamenu, dropdown, or menu links
  if (!$(e.target).closest('.megamenu.nestedmm.menu-item, .dropdown.js-dropdown.menu-item, .js-menu-link').length) {
    // Remove 'menu-item' class from both menus
    $('.megamenu.nestedmm, .dropdown.js-dropdown').removeClass('menu-item');

    // Set aria-expanded to false on menu links
    $('.js-menu-link').attr('aria-expanded', 'false');
  }
});

$(document).on('click', '.slideout__trigger-search-sidebar.js-slideout-close', function() {
  const $searchButton = $('#search-drawer');
  
  // Focus on the button with ID "search-drawer"
  if ($searchButton.length) {
    $searchButton.focus();
    
    // Set aria-expanded to false
    $searchButton.attr('aria-expanded', 'false');
  }
});

$(document).on('keydown', function(event) {
  const $searchDrawer = $('#slideout-search-sidebar');
  
  // Check if the Escape key is pressed and the drawer is active
  if (event.key === 'Escape' && $searchDrawer.hasClass('slideout--active')) {
    setTimeout(function() {
      // Focus on the button with ID "search-drawer"
      const $searchButton = $('#search-drawer');
      if ($searchButton.length) {
        $searchButton.focus();
        // Set aria-expanded to false
        $searchButton.attr('aria-expanded', 'false');
      }
    }, 1000); // 1-second delay before focusing
  }
});

setTimeout(function() {
  $('.swatches__swatch--regular.swatch-element.soldout input').each(function() {
    var inputValue = $(this).val().trim();  // Trim the input value
    $(this).attr('aria-label', inputValue + ' - Sold Out');  // Set aria-label with trimmed value and "Sold Out"
  });
}, 1000);  // Delay in milliseconds (e.g., 1000ms = 1 second)



  $(document).on('click', '.assistance-drop, .sale-drop, .mega-drop', function (event) {
    event.preventDefault(); // Prevent default action for links (if any)
  
    const $button = $(this); // The button that was clicked
    const $dropdown = $button.next('.js-dropdown, .megamenu.nestedmm'); // The associated dropdown (next sibling)
  
    // Close all other dropdowns
    $('.assistance-drop, .sale-drop, .mega-drop').not($button).attr('aria-expanded', 'false');
    $('.js-dropdown, .megamenu.nestedmm').not($dropdown).removeClass('menu-item');
  
    // Toggle the clicked dropdown
    const isExpanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', !isExpanded);
  
    if (!isExpanded) {
      $dropdown.addClass('menu-item');
    } else {
      $dropdown.removeClass('menu-item');
    }
  });

  $(document).on('focusout', '.megamenu.nestedmm.menu-item', function (event) {
    const $dropdown = $(this); // The element losing focus
    const $button = $dropdown.siblings('.js-menu-link'); // The associated button (sibling)
  
    // Delay execution to ensure focus has truly left the dropdown and not just moving within its children
    setTimeout(() => {
        if (!$dropdown.find(':focus').length && !$dropdown.is(':focus')) {
            // Remove 'menu-item' class and update aria-expanded
            $dropdown.removeClass('menu-item');
            $button.attr('aria-expanded', 'false');
        }
    }, 400);
  });
  
  $(document).on('focusout', '.dropdown.js-dropdown.menu-item', function (event) {
    const $dropdown = $(this); // The element losing focus
    const $button = $dropdown.siblings('.js-menu-link'); // The associated button (sibling)
  
    // Delay execution to ensure focus has truly left the dropdown and not just moving within its children
    setTimeout(() => {
        if (!$dropdown.find(':focus').length && !$dropdown.is(':focus')) {
            // Remove 'menu-item' class and update aria-expanded
            $dropdown.removeClass('menu-item');
            $button.attr('aria-expanded', 'false');
        }
    }, 400);
  });

  $('input[data-type="email"]').attr('aria-label','Enter Email');  
  $('textarea[data-type="textarea"]').attr('aria-label','Enter Message');  

    $('a.shg-btn.shg-cse.shg-btn-text[href="https://wwd.com/fashion-news/designer-luxury/carolina-k-store-miami-design-district-1236315001/"]').attr('aria-label','read more about EXCLUSIVE: Carolina K Opens First Boutique in Miami Design District (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://lifestyle.si.com/culture/designers-share-personal-insights-for-hispanic-and-latinx-heritage-month"]').attr('aria-label','read more about Designers Share Personal Insights for Hispanic and Latinx Heritage Month (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.worth.com/luxury-era-sustainable-fashion/"]').attr('aria-label','read more about Unpacking Luxury in the Era of Sustainable Fashion (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.cntraveler.com/story/business-travel-carolina-k"]').attr('aria-label','read more about The New Business Traveler: On a Sourcing Trip to Portugal, Designer Carolina K. Goes With the Flow(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.forbes.com/sites/carolinetell/2023/03/03/how-i-travel-carolina-kleinman/?sh=2517f4ae2874"]').attr('aria-label','read more about How I Travel: Carolina Kleinman (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.harpersbazaar.com/culture/interiors-entertaining/a36534816/carolina-k-ceramics/"]').attr('aria-label','read more about This Ultra-Pretty Ceramics Collection Is Handcrafted by Women in Central America (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://aventuramagazine.com/the-force-of-fashion/"]').attr('aria-label','read more about The Force of Fashion (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.roseandivyjournal.com/stories/2022/3/2/a-look-into-caroline-ks-new-boutique-in-riviera-maya"]').attr('aria-label','read more about A Peek Inside Carolina K New Boutique in Riviera Maya(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.marieclaire.com/fashion/a35915190/carolina-kleinman-interview/"]').attr('aria-label','read more about Carolina Kleinman Invites You into Her Universe (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.harpersbazaar.com/fashion/designers/a38688263/etereo-auberge-mexico/"]').attr('aria-label','read more about Carolina K Celebrates Local Artisans at New Riviera Maya Boutique (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://mlmiamimag.com/carolina-kleinman-boutique"]').attr('aria-label','read more about Style With Conscience(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.forbes.com/sites/sboyd/2021/04/20/4-sustainable-fashion-brands-you-need-to-know/?sh=36aa532860a3"]').attr('aria-label','read more about 4 Sustainable Fashion Brands You Need To Know(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://coveteur.com/carolina-k-home-tour"]').attr('aria-label','read more about Inside A Modern Miami Home Full Of Vibrant Textiles & Vintage Finds (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://fashionweekdaily.com/editors-pick-carolina-ks-debut-ceramics-collection/"]').attr('aria-label','read more about Editors Pick: Carolina K Debut Ceramics Collection(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.createcultivate.com/blog/carolina-kleinman-founder-interview/"]').attr('aria-label','read more about How Carolina Kleinman Built an Ethical Fashion Brand That Employs 300 Artisans Around the World"(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.forbes.com/sites/kristenshirley/2021/04/13/carolina-k-talks-sustainability-and-ethical-fashion/?sh=5680a613604f"]').attr('aria-label','read more about Carolina K Talks Sustainability and Ethical Fashion(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.thezoereport.com/wellness/how-to-prioritize-mental-wellness-female-founders-meditation-yoga-walking"]').attr('aria-label','read more about How These Successful Women Are Putting Their Mental Health First (opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://fashionweekdaily.com/ethical-designer-carolina-k-on-slow-fashion-famous-fans-and-15-years-in-business/"]').attr('aria-label','read more about Ethical Designer Carolina K on Slow Fashion, Famous Fans, and 15 years in Business(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.vogue.mx/moda/articulo/carolina-k-marca-latinoamericana-con-disenos-artesanales-y-latinoamericanos"]').attr('aria-label','read more about Carolina K, la marca latinoamericana valora el trabajo artesanal(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://wp.wearedore.com/style/the-dresses-of-carolina-k/"]').attr('aria-label','read more about The Dresses of Carolina K(opens in a new window)');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://carolinak.com/collections/new-arrivals-1"]').attr('aria-label','Discover more about Ready to Wear');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://carolinak.com/collections/swimwear"]').attr('aria-label','Discover more Swimwear');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://carolinak.com/collections/home"]').attr('aria-label','Discover more about Home Collection');
    $('a.shg-btn.shg-cse.shg-btn-text[href="https://www.nytimes.com/2024/12/02/travel/miami-neighborhoods-guide.html"]').attr('aria-label','Read more about Follow the Lights to Miamis Hot New Neighborhood (opens in a new window)');
    $('a[href="https://carolinak.com/pages/anya-freeman"]').attr('aria-label','learn more about Anya Freeman');

$('a[href="https://carolinak.com/pages/kate-fleming"]').attr('aria-label','learn more about Kate Fleming');
$('a[href="https://carolinak.com/pages/beatriz-chachamovitz"]').attr('aria-label','learn more about Beatriz Chachamovitz');
    

    $(document).on('click', '.slideout__trigger-mobile-menu.js-slideout-open', function () {
      setTimeout(function () {
        const $drawer = $('#slideout-mobile-navigation');
        if ($drawer.length) {
         $('.mobile-menu').removeAttr('aria-hidden', 'true');
       $drawer.attr('tabindex', '-1').focus();  
            }
      }, 100); 
    });



  $('[role="button"]')
  .attr('tabindex', '0')
  .on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); 
      $(this).click();  
    }
  });




  function updateAriaHidden() {
    const $menuItem = $('#menu-item-1');
    if ($(window).width() > 768) {
      $menuItem.attr('aria-hidden', 'true');
    } else {
      $menuItem.removeAttr('aria-hidden');
    }
  }
  updateAriaHidden();
  $(window).on('resize', updateAriaHidden);
  